import React, { useEffect, useRef, useState } from 'react';
import { PhoneNumberField } from 'views/components/form-inputs';
import { InputText } from 'primereact/inputtext';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Message } from 'primereact/message';
import { userService } from 'services/user.service';
import { showTostify } from 'utils/interfaces';
import { Password } from 'primereact/password';
import { Dropdown } from 'primereact/dropdown';
import { Avatar } from 'primereact/avatar';
import CustomToast from 'views/components/form-inputs/alert';
import { useNavigate, useParams } from 'react-router-dom';
import { routes } from 'utils/routes';
import { SEOHeader } from 'views/components';
import statesData from 'static.json'
import axios from 'axios';
import store from 'store'

const ViewEmployee = () => {
  const params = useParams()
  const id: any = params.id
  const [loading, setLoading] = useState(false);
  const toastRef = useRef<any>(null);
  const navigate = useNavigate()
  const [cities, setCities] = useState([]);
  const [selectedFile, setSelectedFile] = useState<any>('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [previewUrl1, setPreviewUrl1] = useState('');
  const [isJobType, setIsJobType] = useState<any>('');
  const [avatar, setAvatar] = useState<any>([]);
console.log(loading);

  const formik: any = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      phone_number1: "",
      phone_number2: "",
      status: "active",
      role: "employee",
      username: "",
      gender: "male",
      email: "",
      password: "",
      job_type: "full_time",
      address1: "",
      address2: "",
      landmark: "",
      postcode: "",
      country: "India",
      state: "",
      city: "",
      company_idnumber: "",
      company_name: "",
      referral_code: "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required('First name is required'),
      username: Yup.string().required('Username is required'),
      password: id ? Yup.string() : Yup.string().required('Password is required'),
      last_name: Yup.string().required('Last name is required'),
      email: Yup.string().email('Invalid email format').required('Email is required'),
      phone_number1: Yup.string().required('Phone number 1 is required'),
      job_type: Yup.string().required('Job type is required'),
      company_name: isJobType === 'student' ? Yup.string().required('Company name is required') : Yup.string(),
      company_idnumber: isJobType === 'student' ? Yup.string().required('Company roll number is required') : Yup.string(),
      status: Yup.string().required('Status is required'),
      city: Yup.string().required('City is required'),
      state: Yup.string().required('State is required'),
      address1: Yup.string().required('Address is required'),
      postcode: Yup.string().required('Postcode is required'),
      gender: Yup.string().required('Gender is required'),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);
      try {
        if (id) {
          // delete 
          const { username, password, referral_code, ...updatedValues } = values;
          const data = await userService.updateUsers(id, updatedValues);
          if (!data.error) {
            showTostify(toastRef, 'success', data.message);
            if (selectedFile) {
              submitFile(id)
            }
            setTimeout(() => {
              navigate(routes.employees);
            }, 800)
          } else {
            showTostify(toastRef, 'error', data.message);
          }
        } else {
          if (values.job_type !== 'student') {
            delete values.role_number
            delete values.company_name
          }
          const data = await userService.createUsers(values);

          if (!data.error) {
            if (selectedFile) {
              submitFile(data.data.id)
            }
            showTostify(toastRef, 'success', data.message);
            formik.resetForm();
            setTimeout(() => {
              navigate(routes.employees);
            }, 800)
          } else {
            showTostify(toastRef, 'error', data.message);
          }
        }
      } catch (err: any) {
        showTostify(toastRef, 'error', err.message);
      } finally {
        setLoading(false);
      }
    }

  });

  useEffect(() => {
    if (id) {
      const fetchEmployeeDetails = async () => {
        const data = await userService.getUserDetails(id);
        if (Array.isArray(data?.media) && data?.media.length > 0) {
          setAvatar(data.media);
        } else {
          console.error('Media array is empty or not an array');
        }
        if (!data.error) {
          formik.setValues({
            first_name: data.first_name || "",
            last_name: data.last_name || "",
            email: data.email || "",
            phone_number1: data.phone_number1 || "",
            phone_number2: data.phone_number2 || "",
            status: data.status || "",
            role: data.role || "employee",
            username: data.username || "",
            gender: data.gender || "",
            password: data.password || "",
            job_type: data.job_type || "",
            address1: data.address1 || "",
            address2: data.address2 || "",
            landmark: data.landmark || "",
            postcode: data.postcode || "",
            country: data.country || "",
            state: data.state || "",
            city: data.city || "",
            company_idnumber: data.company_idnumber || "",
            company_name: data.company_name || "",
            referral_code: data.referral_code || "",
          });
        } else {
          showTostify(toastRef, 'error', data.message);
        }
      };
      fetchEmployeeDetails();
    }
  }, [id]);

  const handleStateChange = (e: any) => {
    const selectedStateId = e.value;
    formik.setFieldValue('state', selectedStateId);
    const selectedState: any = statesData.states.find(state => state.label === selectedStateId);
    if (selectedState) {
      setCities(selectedState.cities);
      formik.setFieldValue('city', '');
    } else {
      setCities([]);
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target && e.target.files) {
      const file = e.target.files[0] || null;
      if (file) {
        setSelectedFile(file);
        setPreviewUrl1(URL.createObjectURL(file));
      }
    } else {
      console.error('No files were selected.');
    }
  };

  const submitFile = async (id: any) => {

    if (selectedFile) {
      const data = new FormData();
      data.append('key', 'profile_picture');
      data.append('entity_id', `${id}`);
      data.append('files', selectedFile);
      data.append('entity_type', `user`);

      try {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}v1/admin/media`, data, {
          headers: { 'Content-Type': 'multipart/form-data', 'Authorization': store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || 'bIESIcg42Wb9') }
        });
				console.log(response);
				

        setPreviewUrl('')
      } catch (error) {
        console.error('Error uploading image:', error);
        alert(error);
      }
    }
  }

  return (
    <div className='flex flex-wrap h-full'>
      <SEOHeader title="Create Employee" />
      <form onSubmit={formik.handleSubmit} style={{ width: "557px", marginRight: "auto" }} >
        <CustomToast ref={toastRef} />
        <div className='p-sidebar-header p-sidebar-custom-header block' style={{ minHeight: "120px", backgroundColor: "#959CB6", width: "100%" }}>
          <h2 className='text-center text-white pt-1 m-0'>View Employee</h2>
        </div>

        <div className='flex flex-column add-new-employee bg-white'>
          <div className='sidebar-avatar flex justify-content-center bg-white pb-1'>
            {avatar?.length > 0 ? (
              <Avatar image={avatar[avatar?.length - 1]?.path} size="xlarge" />
            ) : (
              <Avatar icon="pi pi-user" size="xlarge" />
            )}
          </div>

          <div className='overflow-y-auto pt-5 p-3'>
            <div className="grid m-0">

              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="first_name">First Name<span className='required-field'>*</span></label>
                  <InputText
                    id="first_name"
                    name="first_name"
                    value={formik.values.first_name}
                    placeholder="Enter here"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={formik.touched.first_name && formik.errors.first_name ? 'p-invalid' : ''}
                    readOnly
                  />
                  {formik.touched.first_name && formik.errors.first_name && (
                    <Message severity="error" text={formik?.errors?.first_name} />
                  )}
                </div>
              </div>

              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="last_name">Last Name<span className='required-field'>*</span></label>
                  <InputText
                    id="last_name"
                    name="last_name"
                    value={formik.values.last_name}
                    placeholder="Enter here"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={formik.touched.last_name && formik.errors.last_name ? 'p-invalid' : ''}
                    readOnly
                  />
                  {formik.touched.last_name && formik.errors.last_name && (
                    <Message severity="error" text={formik.errors.last_name} />
                  )}
                </div>
              </div>

              {!id &&
                <>
                  <div className="col-12 md:col-6 lg:col-6">
                    <div className="form-group mb-2">
                      <label htmlFor="username">Username<span className='required-field'>*</span></label>
                      <InputText
                        id="username"
                        name="username"
                        value={formik.values.username}
                        placeholder="Enter here"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={formik.touched.username && formik.errors.username ? 'p-invalid' : ''}
                        readOnly
                      />
                      {formik.touched.username && formik.errors.username && (
                        <Message severity="error" text={formik.errors.username} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 md:col-6 lg:col-6">
                    <div className="form-group mb-2">
                      <label htmlFor="email">Email<span className='required-field'>*</span></label>
                      <InputText
                        id="email"
                        name="email"
                        value={formik.values.email}
                        placeholder="Enter here"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={formik.touched.email && formik.errors.email ? 'p-invalid' : ''}
                        readOnly
                      />
                      {formik.touched.email && formik.errors.email && (
                        <Message severity="error" text={formik.errors.email} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 md:col-6 lg:col-6">
                    <div className="form-group mb-2">
                      <label htmlFor="password">Password<span className='required-field'>*</span></label>
                      <Password
                        id="password"
                        name="password"
                        value={formik.values.password}
                        placeholder="Enter here"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={formik.touched.password && formik.errors.password ? 'p-invalid' : ''}
                        readOnly
                        toggleMask
                      />
                      {formik.touched.password && formik.errors.password && (
                        <Message severity="error" text={formik.errors.password} />
                      )}
                    </div>
                  </div>
                </>}

              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="gender">Gender<span className='required-field'>*</span></label>
                  <Dropdown
                    id="gender"
                    name="gender"
                    value={formik.values.gender || "male"}
                    onChange={(e) => formik.setFieldValue('gender', e.value)}
                    options={[
                      { label: 'Male', value: 'male' },
                      { label: 'Female', value: 'female' },
                      { label: 'Other', value: 'other' },
                    ]}
                    placeholder="Enter here"
                    className="w-full"
                    disabled
                  />
                  {formik.touched.gender && formik.errors.gender && (
                    <Message severity="error" text={formik.errors.gender} />
                  )}
                </div>
              </div>

              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="phone_number1">Mobile<span className='required-field'>*</span></label>
                  <PhoneNumberField
                    value={formik.values.phone_number1}
                    required={true}
                    onBlur={formik.handleBlur}
                    onChange={(phone) => formik.setFieldValue('phone_number1', phone || '')}
                    disabled
                  />
                  {formik.touched.phone_number1 && formik.errors.phone_number1 && (
                    <Message severity="error" text={formik.errors.phone_number1} />
                  )}
                </div>
              </div>

              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="phone_number2">Alternate Mobile</label>
                  <PhoneNumberField
                    value={formik.values.phone_number2}
                    onBlur={formik.handleBlur}
                    onChange={(phone) => formik.setFieldValue('phone_number2', phone || '')}
                    disabled
                  />
                </div>
              </div>

              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="job_type">
                    Employee Type<span className='required-field'>*</span>
                  </label>
                  <Dropdown
                    id="job_type"
                    name="job_type"
                    value={formik.values.job_type || "full_time"}
                    onChange={(e) => {
                      formik.setFieldValue('job_type', e.value);
                      setIsJobType(e.value);
                    }}
                    options={[
                      { label: 'Full Time', value: 'full_time' },
                      { label: 'Part Time', value: 'part_time' },
                      { label: 'Student', value: 'student' },
                    ]}
                    placeholder="Select option"
                    className="w-full"
                    disabled={true}
                  />
                  {formik.touched.job_type && formik.errors.job_type && (
                    <Message severity="error" text={formik.errors.job_type} />
                  )}
                </div>
              </div>


              {formik.values.job_type === 'student' && (
                <>
                  <div className="col-12 md:col-6 lg:col-6">
                    <div className="form-group mb-2">
                      <label htmlFor="company_name">Institute</label>
                      <InputText
                        id="company_name"
                        name="company_name"
                        value={formik.values.company_name}
                        placeholder="Enter here"
                        onChange={formik.handleChange}
                        readOnly
                      />
                      {formik.touched.company_name && formik.errors.company_name && (
                        <Message severity="error" text={formik.errors.company_name} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 md:col-6 lg:col-6">
                    <div className="form-group mb-2">
                      <label htmlFor="company_idnumber">Role Number</label>
                      <InputText
                        id="company_idnumber"
                        name="company_idnumber"
                        value={formik.values.company_idnumber}
                        placeholder="Enter here"
                        onChange={formik.handleChange}
                        readOnly
                      />
                      {formik.touched.company_idnumber && formik.errors.company_idnumber && (
                        <Message severity="error" text={formik.errors.company_idnumber} />
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="state">State<span className='required-field'>*</span></label>
                  <Dropdown
                    showClear
                    id="state"
                    name="state"
                    value={formik.values.state}
                    onChange={handleStateChange}
                    options={statesData?.states?.map(state => ({ label: state.label, value: state.label }))}
                    placeholder="Select option"
                    className="w-full"
                    disabled
                  />
                  {formik.touched.state && formik.errors.state && (
                    <Message severity="error" text={formik.errors.state} />
                  )}
                </div>
              </div>

              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="city">City<span className='required-field'>*</span></label>
                  <Dropdown
                    showClear
                    id="city"
                    name="city"
                    value={formik.values.city}
                    onChange={(e) => formik.setFieldValue('city', e.value)}
                    options={cities.map(city => ({ label: city, value: city }))}
                    placeholder="Select option"
                    className="w-full"
                    disabled={cities.length === 0}
                    readOnly
                  />
                  {formik.touched.city && formik.errors.city && (
                    <Message severity="error" text={formik.errors.city} />
                  )}
                </div>
              </div>

              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="postcode">Postcode<span className='required-field'>*</span></label>
                  <InputText
                    id="postcode"
                    name="postcode"
                    value={formik.values.postcode}
                    placeholder="Enter here"
                    onChange={formik.handleChange}
                    readOnly
                  />
                  {formik.touched.postcode && formik.errors.postcode && (
                    <Message severity="error" text={formik.errors.postcode} />
                  )}
                </div>
              </div>

              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="address1">Address Line 1<span className='required-field'>*</span></label>
                  <InputText
                    id="address1"
                    name="address1"
                    value={formik.values.address1}
                    placeholder="Enter here"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={formik.touched.address1 && formik.errors.address1 ? 'p-invalid' : ''}
                    readOnly
                  />
                  {formik.touched.address1 && formik.errors.address1 && (
                    <Message severity="error" text={formik.errors.address1} />
                  )}
                </div>
              </div>

              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="landmark">Landmark</label>
                  <InputText
                    id="landmark"
                    name="landmark"
                    value={formik.values.landmark}
                    placeholder="Enter here"
                    onChange={formik.handleChange}
                    readOnly
                  />
                  {formik.touched.landmark && formik.errors.landmark && (
                    <Message severity="error" text={formik.errors.landmark} />
                  )}
                </div>
              </div>

              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="address2">Address Line 2</label>
                  <InputText
                    id="address2"
                    name="address2"
                    value={formik.values.address2}
                    placeholder="Enter here"
                    onChange={formik.handleChange}
                    readOnly
                  />
                </div>
              </div>

              <div className="col-12 md:col-6 lg:col-6">
                <div className="form-group mb-2">
                  <label htmlFor="status">Status<span className='required-field'>*</span></label>
                  <Dropdown
                    id="status"
                    name="status"
                    value={formik.values.status ? formik.values.status : "active"}
                    onChange={(e) => formik.setFieldValue('status', e.value)}
                    options={[
                      { label: 'Active', value: 'active' },
                      { label: 'Inactive', value: 'suspended' },
                    ]}
                    placeholder="Select option"
                    className="w-full"
                    disabled={true}
                  />
                  {formik.touched.status && formik.errors.status && (
                    <Message severity="error" text={formik.errors.status} />
                  )}
                </div>
              </div>

              <div className="col-12">
                <ul className="fileupload p-list p-list-custom list-none flex flex-wrap gap-2 p-0 m-0">
                  {previewUrl1 && (
                    <li className="p-list-item">
                      <img
                        src={previewUrl1}
                        alt=""
                        width={80}
                        height={80}
                      />
                    </li>
                  )}
                  {avatar && (avatar?.length > 0 && avatar?.length < 4) &&
                    <>
                      {avatar.map((item: any) => {
                        return (
                          <>
                            <li className="p-list-item">
                              <img src={item?.path} alt="Avatar Preview" width={70} height={70} />
                            </li>
                          </>
                        )
                      })}
                    </>}
                  <li className="p-list-item">
                    <div className="avatar-upload">
                      <div className="avatar-preview">
                        <div className="avatar-upload">
                          <label htmlFor="imageUpload">
                            <i className="pi pi-cloud-upload" style={{ fontSize: '20px' }}></i>
                          </label>
                          <input
                            type="file"
                            id="imageUpload"
                            accept=".png, .jpg, .jpeg"
                            onChange={(e) => {
                              handleImageChange(e);
                            }}
                            style={{ display: 'none' }}
                            disabled
                          />
                          <div className="avatar-preview">
                            <div className="image-preview">
                              {previewUrl && (
                                <img src={previewUrl} alt="Avatar Preview" width={200} height={200} />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="mt-auto flex justify-content-center px-3 mb-3 mx-1 w-full">
          <Button
            label={id ? "Edit Employee" : "Add Employee"}
            type="submit"
            className="primary w-7"
            loading={loading}
          />
        </div> */}
      </form >
    </div >
  );
};
export default ViewEmployee